import { useMemo } from 'react'
import 'react-quill/dist/quill.snow.css'
import { sanitizeBoardHtml } from '../sanitizeBoardHtml'

/** 게시글 본문 — 거른 HTML 을 Quill 1 읽기 스타일(`ql-editor`)로 그린다. `ql-align-*`·`ql-indent-*` 가 1.0 과 같게 보인다. */
export function BoardContent({ html }: Readonly<{ html: string | null | undefined }>) {
  const safe = useMemo(() => sanitizeBoardHtml(html), [html])

  return (
    <div className="ql-snow">
      {/* eslint-disable-next-line react/no-danger -- sanitizeBoardHtml(DOMPurify 허용 목록)을 거친 값만 넣는다 */}
      <div className="ql-editor" style={{ padding: 0, minHeight: 120 }} dangerouslySetInnerHTML={{ __html: safe }} />
    </div>
  )
}
